import React from "react";
import { ActivityLog } from "../../../common/types";
import { Header, Panel } from "@glamcorner/components";
import { ActivityLogItem } from "../ActivityLogItem";
import "./activity-log-component-card.scss";

interface ActivityLogComponentCardProps {
  activityLogs: ActivityLog[];
}

export const ActivityLogComponentCard: React.FC<ActivityLogComponentCardProps> = ({ activityLogs }) => {
  const hasLogs = activityLogs.length !== 0;
  return (
    <Panel className="c-refund-request-activity-log-card" ready={true}>
      <Header onClick={() => {}} withCloseButton={false}>
        Activity Log
      </Header>
      <div className="c-refund-request-activity-log-card__content">
        {hasLogs ? (
          activityLogs.map(log => <ActivityLogItem key={log.id} activityLog={log} />)
        ) : (
          <div>No logs present yet</div>
        )}
      </div>
    </Panel>
  );
};
